import EnvConfig from './envConfig';

const AuthConfig = {
    msalConfig: {
        auth: {
            clientId: EnvConfig.auth.clientId,
            authority: `https://login.microsoftonline.com/${EnvConfig.auth.tenantId}`
        },
        cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            secureCookies: true
        }
    },
    scopes: ["User.Read"],
    extraScopesToConsent: [EnvConfig.auth.apiScope,EnvConfig.gnavAuth.apiScope]
};

// Access scope for Sharepoint API
export const apiTokenRequest = {
    scopes: [EnvConfig.auth.apiScope],
    account: ''
};

export default AuthConfig;